/**
 * @param {Element} el
 * @returns {Number} height
 */
function getElementHeight(el) {
    // parseInt will strip "px" from values like "1024px".
    return parseInt(window.getComputedStyle(el).getPropertyValue('height'));
}

/**
 * Calculates point of scroll handler activation.
 *
 * Right now it's doing it wrong, because it assumes the elements start at the same height.
 * You can adjust that with additional `distance` variable, but it won't work if you resize the page.
 *
 * @param {Element} element scrolled element
 * @param {Element} root Root element
 * @param {string} distance Additional offset to apply in the calculation.
 * @returns {number}
 */
function calculateOffset(element, root, distance) {
    var additionalOffset = distance || 50;
    var elHeight = getElementHeight(element[0]);
    var rootElHeight = window.self === root ? window.innerHeight : getElementHeight(root);

    return Math.abs(elHeight - rootElHeight - additionalOffset);
}

angular
    .module('flex', [])
    .value('$flex.data', {})
    .factory('$flex.scroll', [
        '$window',
        function ($window) {
            var $scroll = {
                offset: undefined,
                calculate: function (element, root, distance) {
                    $scroll.offset = calculateOffset(element, root, distance);
                },
                group: {
                    current: 'default',
                    dependence: {},
                },
                chain: {},
                append: function (name, group) {
                    $scroll.chain[name] = false;
                    $scroll.group.dependence[name] = group ? group : 'default';
                },
                renew: function (name) {
                    if ($scroll.chain[name]) $scroll.chain[name] = false;

                    $scroll.offset = undefined;
                },
                switch: function (group) {
                    $scroll.group.current = group;
                    $scroll.offset = undefined;
                },
            };

            return $scroll;
        },
    ])
    .factory('$flex.hash', [
        '$location',
        function ($location) {
            return {
                get: function () {
                    return $location.hash();
                },
                set: function (hash) {
                    $location.hash(hash).replace();

                    return this;
                },
            };
        },
    ])
    .factory('$flex.array', [
        function () {
            return {
                $splice: function (dist, item, key) {
                    for (var i = 0; i < dist.length; ++i) {
                        var $item = dist[i];

                        if ($item[key] === item[key]) {
                            dist.splice(i, 1);
                        }
                    }

                    return dist;
                },
                $has: function (dist, item, key) {
                    for (var i = 0; i < dist.length; ++i) {
                        var $item = dist[i];

                        if ($item[key] === item[key]) {
                            return true;
                        }
                    }

                    return false;
                },
            };
        },
    ])
    .factory('$flex.touch', [
        '$rootScope',
        function ($scope) {
            var events = [];
            var reloadEvents = ['analytic', 'privacy'];

            return {
                make: function (event) {
                    if (events.indexOf(event) === -1 || reloadEvents.indexOf(event) !== -1) {
                        $scope.$broadcast('touch:' + event);
                        events.push(event);
                    }
                },
                has: function (event) {
                    return events.indexOf(event) !== -1;
                },
            };
        },
    ])
    .filter('insecureUrl', [
        '$sce',
        function ($sce) {
            return function (url) {
                return $sce.trustAsUrl(url);
            };
        },
    ])
    .factory('$flex', [
        '$flex.hash',
        '$flex.touch',
        '$flex.scroll',
        '$flex.data',
        function ($hash, $touch, $scroll, $data) {
            return {
                $hash: $hash,
                $scroll: $scroll,
                $touch: $touch,
                data: $data,
            };
        },
    ])
    .filter('bytes', function () {
        return function (bytes, precision) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
            if (typeof precision === 'undefined') precision = 1;
            var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
                number = Math.floor(Math.log(bytes) / Math.log(1024));
            return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
        };
    })
    .directive('flexData', [
        function () {
            return {
                priority: 100,
                require: 'ngModel',
                link: function (scope, element, attr, model) {
                    var val = element.text().trim();

                    try {
                        val = angular.fromJson(val);
                    } catch (e) {
                    } finally {
                        model.$setViewValue(val);
                        model.$render();

                        element.remove();

                        if (attr.flexAfter) {
                            scope.$eval(attr.flexAfter);

                            if (!scope.$$phase) scope.$digest();
                        }
                    }
                },
            };
        },
    ])
    .directive('flexTouch', [
        '$flex.touch',
        function ($touch) {
            return {
                priority: 100,
                link: function (scope, element, attr, model) {
                    var touched = false;
                    element.bind('click', function () {
                        if (touched === false) {
                            touched = true;
                            $touch.make(attr.flexTouch);
                        }
                    });
                },
            };
        },
    ])
    .directive('script', [
        '$flex.data',
        function ($data) {
            return {
                priority: 20,
                restrict: 'E',
                link: function (scope, element, attrs) {
                    if (attrs.type !== 'text/flex+data') return;

                    var value = element.text().trim();

                    try {
                        value = angular.fromJson(value);
                    } catch (e) {
                        //
                    } finally {
                        if (attrs.name) {
                            $data[attrs.name] = value;
                        } else {
                            console.log('Flex Data', $data, value);
                            angular.extend($data, value);
                        }

                        element.remove();
                    }
                },
            };
        },
    ])
    .directive('flexScroll', [
        '$flex.scroll',
        '$parse',
        '$timeout',
        function ($scroll, $parse, $timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element, $attr) {
                    var SCROLL_GROUP_DEFAULT = '__default__';

                    /**
                     * NOTE: I'm not sure about the purpose :)
                     *
                     * Name of the scope for the scrolled element.
                     * This is used as key value to cache some state, so make sure it's unique on page.
                     */
                    var scrollChainName = $attr.flexScroll;

                    /**
                     * The distance to the top of the list from which to start loading data.
                     */
                    var scrollDist = parseInt($attr.flexScrollDist);

                    /**
                     * Similar to scrollChainName?
                     */
                    var scrollGroup = $attr.flexScrollGroup || SCROLL_GROUP_DEFAULT;

                    /**
                     * Expected scroll direction based on "reverse" flag.
                     *
                     * @type {string}
                     */
                    var isScrollingUp = $attr.flexScrollReverse !== undefined;

                    /**
                     * Element that we are scrolling inside.
                     * @type {Window, HTMLElement}
                     */
                    var scrollRootEl = $attr.flexScrollRoot ? document.querySelector($attr.flexScrollRoot) : window;

                    var handler = $attr.flexScrollFn;

                    /**
                     * Allows you to trigger debug for given scroll.
                     * @type {boolean}
                     */
                    var debug = $attr.flexScrollDebug !== undefined;

                    $scroll.append(scrollChainName, scrollGroup);

                    /**
                     * When a handler is started for given chain name we create a **lock** to prevent repeated calls.
                     * After the handler is completed, we need to **unlock**.
                     *
                     * The lock/unlock process might break the scroll functionality if you forget to unlock.
                     */
                    function unlockChain() {
                        $scroll.chain[scrollChainName] = false;
                        $scroll.calculate($element, scrollRootEl, scrollDist);
                    }

                    function slowScrollingUp(scrollRootEl, scrollDist, scrollViewOffset) {
                        setTimeout(function () {
                            if (scrollRootEl.scrollTop > scrollViewOffset) return;

                            scrollRootEl.scrollTop = --scrollViewOffset;
                            if (scrollDist-- && scrollDist > 11) {
                                slowScrollingUp(scrollRootEl, scrollDist, scrollViewOffset);
                            }
                        }, 10);
                    }

                    // Bind to the scroll event on the root Element
                    angular.element(scrollRootEl).bind('scroll', function () {
                        debug && console.log('SCROLLING...'); // jshint ignore:line

                        // this calculates something...
                        if (!$scroll.offset) {
                            $scroll.calculate($element, scrollRootEl, scrollDist);
                        }

                        var currentOffset = calculateOffset($element, scrollRootEl, scrollDist);

                        var scrollViewOffset = this.pageYOffset || this.scrollTop;

                        if (scrollViewOffset < scrollDist && isScrollingUp) {
                            if (scrollViewOffset <= 10) {
                                scrollRootEl.scrollTop = 10;
                            } else {
                                slowScrollingUp(scrollRootEl, scrollDist, scrollViewOffset);
                            }
                        }

                        var hasReachedScrollThreshold = isScrollingUp
                            ? currentOffset > scrollViewOffset
                            : currentOffset < scrollViewOffset;

                        if (!hasReachedScrollThreshold) return;

                        debug && console.log('REACHED END!'); // jshint ignore:line

                        // ---------------------- CONTINUE PROCESSING ----------------------

                        // A flag is set to `true` when we decide to start the scroll handler callback.
                        // It's set to `false` when the handler callback is signals it.
                        var isScrollChainBusy = $scroll.chain[scrollChainName];

                        // I'm not sure what are groups for and if we need this check at all or maybe it should be different.
                        var isCurrentGroup =
                            scrollGroup === SCROLL_GROUP_DEFAULT || $scroll.group.current === scrollGroup;

                        debug && console.log('\t Chain busy?', isScrollChainBusy); // jshint ignore:line
                        debug && console.log('\t Groups', $scroll.group.current, scrollGroup); // jshint ignore:line

                        // return if we haven't finished processing previous event
                        if (isScrollChainBusy || !isCurrentGroup) return;

                        // ---------------------- CONTINUE PROCESSING ----------------------

                        $scroll.chain[scrollChainName] = true;

                        var $handler = $parse(handler)($scope);

                        if (!$handler) return; // no handler was passed, so we are done

                        // ---------------------- CONTINUE PROCESSING ----------------------

                        debug && console.log('HANDLER', handler); // jshint ignore:line

                        /**
                         * Our handler might return a promise or it might just take a callback function.
                         * We try to do both here so we can support the new `MessageManagerFactory.QueryPromise`.
                         *
                         * WARNING! The callback might not be called! This might be causing bugs!
                         * If you have problems like that consider implementing a Promise based handler.
                         *
                         * @var Promise
                         */
                        var mightBePromise = $handler(unlockChain);

                        // We need to check if this is Promise-like interface,
                        // because we don't get an actual Promise implementation from Angular...
                        var isActuallyPromise = mightBePromise && typeof mightBePromise.then === 'function';

                        if (!isActuallyPromise) return;

                        // ---------------------- CONTINUE PROCESSING ----------------------

                        mightBePromise.finally(unlockChain);
                    });
                },
            };
        },
    ])
    .directive('flexFile64', [
        '$q',
        '$timeout',
        '$http',
        function ($q, $timeout, $http) {
            return {
                restrict: 'EA',
                require: 'ngModel',
                // scope: false,
                link: function ($scope, $element, $attrs, $model) {
                    var $files = [];
                    var $collection = [];

                    var $flexexec = function ($file, $call) {
                        var $reader = new FileReader();

                        $reader.onabort = function ($e) {
                            $model.$setValidity('abort', false);

                            if ($attrs.flexOnabort) $scope.$eval($attrs.flexOnabort);
                        };

                        $reader.onloadstart = function ($e) {
                            if ($attrs.flexOnloadstart) $scope.$eval($attrs.flexOnloadstart);
                        };

                        $reader.onload = function ($e) {
                            if ($attrs.flexOnload) $scope.$eval($attrs.flexOnload);
                        };

                        $reader.onloadend = function ($e) {
                            if ($attrs.flexOnloadend) $scope.$eval($attrs.flexOnloadend);

                            $call($reader);
                        };

                        if ($attrs.flexOnprogress) $reader.onprogress = $scope.$eval($attrs.flexOnprogress);

                        $reader.onerror = function ($e) {
                            $model.$setValidity('load', false);

                            if ($attrs.flexOnerror) $reader.onerror = $scope.$eval($attrs.flexOnerror);
                        };

                        $reader.readAsDataURL($file);
                    };

                    var $flexread = function ($next) {
                        var $promises = [];

                        angular.forEach($files, function ($file) {
                            var $accept = $attrs.flexType
                                ? new RegExp($attrs.flexType.replace(/\*/i, '.*?'))
                                : undefined;

                            if ($attrs.flexMinitem && $files.length < $attrs.flexMinitem) {
                                /**
                                 *
                                 */
                                $model.$setValidity('minitem', false);
                                if ($attrs.flexOnerror) $scope.$eval($attrs.flexOnerror);
                            } else if ($attrs.flexMaxitem && $files.length > $attrs.flexMaxitem) {
                                /**
                                 *
                                 */
                                $model.$setValidity('maxitem', false);
                                if ($attrs.flexOnerror) $scope.$eval($attrs.flexOnerror);
                            } else if ($attrs.flexMinsize && $file.size < $attrs.flexMinsize) {
                                /**
                                 *
                                 */
                                $model.$setValidity('minsize', false);
                                if ($attrs.flexOnerror) $scope.$eval($attrs.flexOnerror);
                            } else if ($attrs.flexMaxsize && $file.size > $attrs.flexMaxsize) {
                                /**
                                 *
                                 */
                                $model.$setValidity('maxsize', false);
                                if ($attrs.flexOnerror) $scope.$eval($attrs.flexOnerror);
                            } else if ($accept && !$accept.test($file.type)) {
                                /**
                                 *
                                 */
                                $model.$setValidity('accept', false);
                                if ($attrs.flexOnerror) $scope.$eval($attrs.flexOnerror);
                            } else {
                                var $defer = $q.defer();

                                $flexexec($file, function ($reader) {
                                    $defer.resolve({
                                        reader: $reader,
                                        file: $file,
                                    });
                                });

                                $promises.push($defer.promise);
                            }
                        });

                        $q.all($promises).then(function ($dataset) {
                            $collection = [];

                            angular.forEach($dataset, function ($data) {
                                if ($data.reader.error === null)
                                    $collection.push({
                                        name: $data.file.name,
                                        size: $data.file.size,
                                        type: $data.file.type,
                                        base: $data.reader.result,
                                        file: $data.file,
                                    });
                            });

                            $next($collection);
                        });
                    };

                    var $flexprepare = function () {
                        $model.$setValidity('minsize', null);
                        $model.$setValidity('maxsize', null);
                        $model.$setValidity('minitem', null);
                        $model.$setValidity('maxitem', null);
                        $model.$setValidity('accept', null);
                        $model.$setValidity('abort', null);
                        $model.$setValidity('load', null);

                        $files = $element[0].files;

                        if ($attrs.flexStart) {
                            var $call = $scope.$eval($attrs.flexStart);

                            if ($call) {
                                $call();
                                $scope.$apply();
                            }
                        }

                        var $defer = $q.defer();

                        $defer.resolve(function ($collection) {
                            $model.$setViewValue($attrs.multiple ? $collection : $collection[0]);

                            if ($attrs.flexEnd) {
                                var $call = $scope.$eval($attrs.flexEnd);

                                if ($call) $call();
                            }

                            $element.val('');
                        });

                        $timeout(function () {
                            $defer.promise.then($flexread);
                        }, 0);
                    };

                    $element.bind('change', $flexprepare);
                },
            };
        },
    ]);
